import React from 'react';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';

import {
    StyledCategories,
    StyledCategory,
    StyledCategoryName,
    StyledCheckIcon,
} from './ancestors.style';
import { FilterItemWithState } from '../../../filters/util';

const Ancestors = ({
    categories,
    onCategorySelect,
}: {
    categories: FilterItemWithState[];
    onCategorySelect: Function;
}) => {
    return (
        <StyledCategories>
            {categories.map(({ label, value, isChecked }) => {
                return (
                    <StyledCategory key={value}>
                        <StyledCategoryName
                            {...qaAttribute('ancestor-category-name')}
                            isSelected={isChecked}
                            key={value}
                            onClick={() => onCategorySelect(value)}
                        >
                            {label}
                        </StyledCategoryName>
                        {isChecked && (
                            <StyledCheckIcon
                                {...qaAttribute('ancestor-category-name-check-icon')}
                                type="check"
                            />
                        )}
                    </StyledCategory>
                );
            })}
        </StyledCategories>
    );
};

export default Ancestors;
